import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { landingFor } from "@/lib/nav";
import Login from "@/pages/Login";
import DispenserSearch from "@/pages/DispenserSearch";
import AdminConsole from "@/pages/AdminConsole";
import HODPortal from "@/pages/HODPortal";
import Analytics from "@/pages/Analytics";
import Activity from "@/pages/Activity";
import ResourcesView from "@/pages/ResourcesView";
import RolesTracker from "@/pages/RolesTracker";
import KnowledgeBank from "@/pages/KnowledgeBank";
import { Loader2 } from "lucide-react";

function Boot() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <Loader2 className="h-6 w-6 animate-spin text-sky-600" />
    </div>
  );
}

function Guard({ children, roles }) {
  const { user, booting } = useAuth();
  if (booting || user === null) return <Boot />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={landingFor(user)} replace />;
  return children;
}

function LandingRedirect() {
  const { user, booting } = useAuth();
  if (booting || user === null) return <Boot />;
  return <Navigate to={landingFor(user)} replace />;
}

function LoginGate() {
  const { user, booting } = useAuth();
  if (booting || user === null) return <Boot />;
  if (user) return <Navigate to={landingFor(user)} replace />;
  return <Login />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginGate />} />
          <Route path="/" element={<LandingRedirect />} />
          <Route path="/search" element={<Guard roles={["super_admin", "hod", "dispenser"]}><DispenserSearch /></Guard>} />
          <Route path="/resources" element={<Guard roles={["super_admin", "hod", "dispenser"]}><ResourcesView /></Guard>} />
          <Route path="/roles" element={<Guard roles={["super_admin", "hod", "dispenser"]}><RolesTracker /></Guard>} />
          <Route path="/knowledge" element={<Guard roles={["super_admin", "hod", "dispenser"]}><KnowledgeBank /></Guard>} />
          <Route path="/admin" element={<Guard roles={["super_admin"]}><AdminConsole /></Guard>} />
          <Route path="/hod" element={<Guard roles={["super_admin", "hod"]}><HODPortal /></Guard>} />
          <Route path="/analytics" element={<Guard roles={["super_admin", "hod"]}><Analytics /></Guard>} />
          <Route path="/activity" element={<Guard roles={["super_admin", "hod"]}><Activity /></Guard>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
